export default __webpack_public_path__ + "static/GavulaXMas--2022-321b37aade423adbafbfb0410eb80194.pdf";